<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<div>
								<p class="mb-0 font-weight-bold text-primary title">Copiar Etapa</p>
								<p class="mb-0 caption text-primary">Selecciona hacia donde quieres copiar esta etapa y su configuración</p>
							</div>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <v-form ref="form" v-model="validform" class="mt-6">
							<div class="d-flex align-center justify-space-between mb-4">
								<div v-if="isGeneralStage">
									<p class="mb-0 font-weight-bold caption">Etapa Para Zona</p>
									<p class="mb-0" style="font-size: 10px">Etapa general para zona de proyecto</p>
								</div>
								<div v-else>
									<p class="mb-0 font-weight-bold caption">Etapa Específica</p>
									<p class="mb-0" style="font-size: 10px">Para la Zona y Tipo de Proyecto seleccionados</p>
								</div>
								<div class="d-flex flex-column align-center justify-center">
									<p class="mb-0 font-weight-bold" style="font-size: 10px">Tipo de Etapa</p>
									<v-switch
										class="mt-0"
										color="#FF120B"
										dense
										hide-details
										v-model="isGeneralStage"
									></v-switch>
								</div>
							</div>
							<v-select
								v-model="zoneId"
								:items="$store.state.projects.zoneIpt"
								:loading="$store.state.projects.loadingZoneIpt"
								:menu-props="{ top: true, offsetY: true }"
								item-text="name"
								item-value="id"
								label="Selecciona Zona Proyecto"
								class="custom-height-search custom-height-calendar flex-grow-0 mb-6"
								outlined
								hide-details
								dense
								required
								:rules="requiredRule"
							></v-select>

							<v-combobox
								v-if="!isGeneralStage"
								v-model="projectType"
								:items="projectTypeOptions"
								:filter="customFilter"
								:loading="$store.state.companies.loadingCompaniesProjectTypes"
								item-text="name"
								item-value="value"
								dense
								outlined
								label="Selecciona tipo de proyecto"
								clearable
								:rules="requiredRule"
							>
								<template v-slot:item="{ item }">
									<div v-if="item.header" class="font-weight-bold caption">
										{{ item.header }}
									</div>
									<div v-else-if="item.isSubType" class="caption ml-2">
										{{ item.name }}
									</div>
									<div v-else class="caption font-weight-bold">
										{{ item.name }}
									</div>
								</template>
							</v-combobox>

              <v-row align="center">
                <v-col cols="12">
                  <div class="d-flex flex-row justify-end">
                    <v-btn
                      class="mx-2 my-1"
                      color="white"
                      raised
                      @click="closeModal"
                    >
                      <p class="mb-0 text-primary">Cancelar</p>
                    </v-btn>
                    <v-btn
                      class="mx-2 my-1"
                      color="#524D4D"
                      raised
                      dark
                      :loading="loadingCopy"
                      @click="confirmZone"
                    >
                      <p class="mb-0">Confirmar</p>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import {copyProjectPlaningStage} from '@/helpers/api/projects'

export default {
  name: 'CopyCompanyStage',
	props: {
		reload: {
      type: Function,
      required: true
    }
	},
  data: () => ({
		indexModal: + new Date(),
    validform: true,
		loadingCopy: false,
		projectType: null,
		isGeneralStage: true,
		zoneId: null,
		newStageName: null,
    requiredRule: [
      v => !!v || 'Campo requerido'
    ]
  }),
  computed: {
		projectTypeOptions() {
			const options = [];
			if(!this.$store.state.companies.companiesProjectTypesCategories) return options
			this.$store.state.companies.companiesProjectTypesCategories.forEach(category => {
				options.push({ header: category.name });
				category.project_types.forEach(pt => {
					options.push({ name: pt.name, value: pt.id, isParent: true, sub_types: pt.sub_types });
					pt.sub_types.forEach(st => {
						options.push({ name: st.name, value: st.id, isSubType: true });
					});
				});
			});
			return options;
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
  },
  mounted(){
		this.$modal.show('custom_drag_modal')
			this.$store.commit('general/addOpenModalOrders', this.indexModal)
  },
  methods: {
		customFilter(item, queryText, itemText) {
			if (item.header) return true;
			const text = (itemText || '').toLowerCase();
			const query = queryText.toLowerCase();
			if (text.includes(query)) return true;
			if (item.isParent && item.sub_types?.some(st => st.name.toLowerCase().includes(query))) {
				return true;
			}
			return false;
		},
    closeModal(){
			this.$store.commit('projects/setToCopyCompanyPlanningCategoryId', null)
			this.projectType = null
			this.zoneId = null
      this.validform = true
      this.loadingCopy = false
    },
		async confirmZone(){
      if(this.$refs.form.validate()){
				this.loadingCopy = true
				const data = {
					zone_id: this.zoneId,
					project_type_id: this.projectType,
					project_planning_category_id: this.$store.state.projects.toCopyCompanyPlanningCategoryId
				}
				const category = await copyProjectPlaningStage(data)
				if(category.code == 200){
					this.reload({
						zone_id: this.zoneId,
						project_type_id: this.projectType,
						project_planning_category_id: category.new_category.id
					})
					this.closeModal()
				}
				this.loadingCopy = false
			}
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
		position: relative;
		width: 200px;
	}
	.profile-image{
		width: 100%;
		height: 150px;
	}
	.logo-text{
		position: absolute;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.7);
		width: 100%;
		color: white;
		font-size: 12px;
		padding: 5px 10px;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>